import { Injectable } from '@angular/core';
import { Content, Course, AuthorizedUser, Question, QuestionState, Credidentials, Review, ReviewStatistic, Test, TestQuestion, Message, MessageType, HighScoreItem, HighScore, Messages, Config } from './streber-interfaces';
import { QuestionManager } from './question-manager';

import { UserService } from './user.service';
import { ToolsService } from './tools.service';
import { Observable, Subscription } from 'rxjs';

import { Auth, getAuth, signInWithEmailAndPassword } from "@angular/fire/auth";
import { getFirestore, Firestore, collection, getDocs, query, where, getDoc, 
         setDoc, addDoc, updateDoc, increment, runTransaction, Timestamp, serverTimestamp, 
         onSnapshot, writeBatch, doc, limit, orderBy, startAfter } from '@angular/fire/firestore';

import { Functions, getFunctions, httpsCallable } from '@angular/fire/functions';

import { TranslateService } from '@ngx-translate/core';
import { onAuthStateChanged } from 'firebase/auth';

const DEBUG_DONT_MIX_TESTS = false;

@Injectable({
  providedIn: 'root'
})
export class DataService {


  //bei jedem Deployment ändern - MIT DER DB VERGLEICHEN (TODO)
  public appVersion: string = "1.03.01"; 

  //mögliche States der App:
  //nictht eingeloggt: this.afAuth.auth.currentUser.uid == null
  public coursesAreLoaded: boolean = false;
  public currentCourse: Course; //course currently loaded
  public inProgress: boolean = false; //indicates, that some login or loading is in progress
  
  // for subscribing to the user's questions of a specific modul
  //public itemsCollection: AngularFirestoreCollection<Question>;
  //public questionObservable: Observable<Question[]>;
  //public questionSubsription: Subscription;
  private unsubscribeQuestions; //function to unsubscribe, returnd by querysnapshot

  // for subscribing to the HighScore
  public highScoreSubscription: Subscription;
  public UnsubscribeFromHighScore: Function;
  public highScore: HighScore;
  public highScoreDateTime: string;
  public HighScoreLoadingInitiated: boolean = false;
  public userIsInHighScore: boolean = false;

  // load content for Info
  public infoContent: Content;

  //public currentQuestion: Question;
  public questions: Question[];

  constructor(private user: UserService,
              //public afAuth: AngularFireAuth,
              //public afs: AngularFirestore,
              //private fns: AngularFireFunctions,
              public auth: Auth,
              public firestore: Firestore,
              private functions: Functions, //unsicher ob das in der modular API nötig ist
              private tools: ToolsService,
              private translate: TranslateService) { 
    this.checkVersion().then(result=>{
      if(result) this.monitorAuthetication(); 
    });
      
  }

  //done
  private async checkVersion(): Promise<boolean> {
    console.log("in checkVersion");
    //let doc = await this.afs.collection("Config").doc("CurrentConfig").get().toPromise();
    let docRef =(doc(this.firestore, "Config", "CurrentConfig"));
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      let config = <Config> docSnap.data();
      console.log("MinVersion from Config-Collection: "+config.MinVersion);
      if (config.MinVersion > this.appVersion) {
        this.tools.presentAlert2(["GENERAL.CAUTION"], ["DATA.NEWVERSION",
          "DATA.YOURVERSION", this.appVersion, 
          "DATA.CURRENTVERSION", config.Version, 
          "DATA.MUSTUPDATE"]);
        return false;
      } else {
        if (config.Version > this.appVersion) {
          this.tools.presentAlert2(["GENERAL.CAUTION"], ["DATA.NEWVERSION",
          "DATA.YOURVERSION", this.appVersion, 
          "DATA.CURRENTVERSION", config.Version, 
          "DATA.SHOULDUPDATE"]);
          return true;
        } 
        return true;
      }
    } else {
      console.log("checkVersion: Dokument nicht gefunden")
    }
  }

  //done
  private monitorAuthetication() {
      onAuthStateChanged(this.auth, user => {
        this.user.afUser = user;
        this.inProgress = true;
        if (user) {
          console.log("User is logged in: ", user.uid);
          this.user.getUserDetails(user.uid).then((authUser: AuthorizedUser)=>{
            if (authUser) {
              if (authUser.preferedLanguage && authUser.preferedLanguage!="") {
                console.log("Prefered Language found: ", authUser.preferedLanguage);
                this.translate.use(authUser.preferedLanguage);
              } else {
                console.log("User has no prefered language");
                console.log("Default Language: ", this.translate.currentLang);
              }
              if (authUser.lastCourse && authUser.lastCourse != "") {
                console.log("found lastcourse: ", authUser.lastCourse);
                this.loadCourseAndCourseData(user.uid, authUser.lastCourse);
              } else {
                this.tools.presentAlert("GENERAL.NOTE","DATA.NOTINCOURSE");
              }
              this.inProgress = false;
            }
          });
        } else {
          this.inProgress = false;
          this.unLoadMyQuestions();
          this.user.currentAuthorizedUser = null;
          this.user.currentUserCourse = null;
          this.currentCourse = null;
          console.log("afAuth.auth.onAuthStateChanged: user object ist Null")          
        }
      },(error)=>{
          console.log("afAuth.auth.onAuthStateChanged: ", error);
          this.inProgress = false;
      });
  }

  //done
  public async enterCourse(cid: string): Promise<boolean> {
    this.currentCourse = null;
    this.coursesAreLoaded = false;
    if (this.user.currentAuthorizedUser) {
      this.user.dropUserCourse();
      this.stopMonitoringHighScore();
      this.unLoadMyQuestions();
      let success = await this.loadCourseAndCourseData(this.user.currentAuthorizedUser.uid,cid);
      if (success) {
        console.log("try setting lastcourse in user-object");
        //this.afs.collection("Users").doc(this.user.currentAuthorizedUser.uid).update({lastCourse: cid});
        updateDoc(doc(this.firestore, "Users", this.user.currentAuthorizedUser.uid), {lastCourse: cid});
        console.log("lastcourse set");
        return true;
      } else
        return false;
    } else {
      this.tools.presentAlert("GENERAL.ERROR","You are not logged in.");
      return false;
    }
  }

  public async loadCourseAndCourseData(uid: string, cid: string): Promise<boolean> {
    try {
      let success = await this.loadCourse(cid);
      if (success) {
        this.user.monitorUserCourse(uid,cid);
        console.log("Courses loaded");
        return true;
      } 
      this.inProgress = false;
    } catch(error) {
      console.log("loadCourse: ", error)
      this.inProgress = false;
      return false;
    };
  }

  //done
  public async loadCourse(cid: string): Promise<boolean> {
    try {
      //let doc = await this.afs.collection("Courses").doc(cid).get().toPromise();
      let docu = await getDoc(doc(this.firestore, "Courses", cid));
      if (docu.exists()) {
        let currentCourse = <Course>docu.data();
        if (!currentCourse.maxDailyTrainings) currentCourse.maxDailyTrainings = -1;
        console.log("Course " + currentCourse.cid + "loaded - maxDailyTrainings: " + currentCourse.maxDailyTrainings);
        if (currentCourse.identifierRegExp.length>0) {
          let regexp = new RegExp(currentCourse.identifierRegExp)
          if (regexp.test(this.user.currentAuthorizedUser.identifier)){
            this.coursesAreLoaded = true;
            this.currentCourse = currentCourse;
            if (this.HighScoreLoadingInitiated) this.monitorHighScore();
            return true;
          } else {
            this.tools.presentAlert("GENERAL.NOTALLOWED",currentCourse.validIdentifierMessage);
            // this.currentCourse = null;
            // this.coursesAreLoaded = false;
            // this.user.dropUserCourse();
            return false;
          }
        } else {
          this.coursesAreLoaded = true;
          this.currentCourse = currentCourse;
          if (this.HighScoreLoadingInitiated) this.monitorHighScore();
          return true;
        }
      } else {
        console.error("Course not found!");
        this.tools.presentAlert2(["GENERAL.SORRY"],["DATA.COURSENOTFOUND1",cid,"DATA.COURSENOTFOUND2"]);
        return false;
      }
    } catch (error){
      console.error("Fehler beim Laden des Kurses: ", error)
      return false;
    }
  }

  public getNewQuestion(mid: string): Question {
    if (this.user.currentAuthorizedUser) {
      let q: Question = QuestionManager.newQuestion();
      q.creator.uid = this.user.currentAuthorizedUser.uid;
      q.creator.nickname = this.user.currentAuthorizedUser.nickname;
      q.cid = this.currentCourse.cid;
      q.mid = mid;
      return q;
    } else {
      return null;
    }
  }

  //done
  public async saveQuestion(q: Question): Promise<boolean> {
    if (q.qid == "") {
      //q.qid = this.afs.createId();
      q.qid = doc(collection(this.firestore,"Questions")).id;
    } 
    //console.log(q);
    if (q.state == QuestionState.Saved) {   
      try {
        //await this.afs.doc("Questions/"+q.qid).set(q);
        await setDoc(doc(this.firestore, "Questions", q.qid), q);
        console.log("gespeichert");
        return true;
      } catch (error) {
        console.log(error);
      }
    } else {
      this.tools.presentAlert("SGENERAL.ERROR","Only new, not submitted questions can be saved.");
      return false;
    }
  }

  //done
  public async setBestReviewer(q: Question, reviewerId: string): Promise<boolean> {
    if (q.state == QuestionState.Submitted) {
      if (reviewerId!="" && !q.reviews.some(r=>r.user.uid==reviewerId && r.comment!="")) { 
        console.log("Reviewer existiert nicht oder hat kein Review geschrieben");
        return false;
      }
      try {
        //await this.afs.collection("Questions").doc(q.qid).update({bestReviewerId: reviewerId});
        await updateDoc(doc(this.firestore, "Questions", q.qid), {bestReviewerId: reviewerId});
        q.bestReviewerId = reviewerId;
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } 
    return false; //in allen anderen Fällen
  }

  //done
  public async submitQuestion(q: Question): Promise<boolean> {
    if (q.state==QuestionState.Saved) {
      if (q.qid == "") {
        //q.qid = this.afs.createId();
        q.qid = doc(collection(this.firestore,"Questions")).id;
      }
      q.state = QuestionState.Submitted;
      q.version = 1;
      //let batch = this.afs.firestore.batch();
      let batch = writeBatch(this.firestore);
      // Frage
      //let qref = this.afs.collection("Questions").doc(q.qid).ref;
      let qref = doc(this.firestore, "Questions", q.qid);
      //q.created = firebase.firestore.FieldValue.serverTimestamp();
      q.created = serverTimestamp();
      //console.log(JSON.stringify(q));
      batch.set(qref,q);
      //UserCourse - Punkte
      //let uref = this.afs.collection("UserCourses").doc((await this.afAuth.currentUser).uid+"-"+this.currentCourse.cid).ref;
      let uref = doc(this.firestore, "UserCourses", (this.auth.currentUser.uid+"-"+this.currentCourse.cid));

      let updateobject = {
        points: increment(this.currentCourse.points.PointsPerCreatedQuestion),
        countQuestions: increment(1),
        lastDay: serverTimestamp()
      };
      //console.log(JSON.stringify(updateobject));
      batch.update(uref,updateobject);

      //let lref = this.afs.collection("Log").doc(this.afs.createId()).ref;
      let lref = doc(this.firestore, "Log", doc(collection(this.firestore, "Log")).id);
      let updateobject2 = {
        uid: (this.auth.currentUser).uid, //mandatory
        cid: this.currentCourse.cid, //mandatory
        mid: q.mid, //bei Bedarf
        qid: q.qid, //bei Bedarf
        tid: "", //Trainigs-ID
        type: 1,
        logdate: serverTimestamp()
      }
      console.log(JSON.stringify(updateobject2));
      batch.set(lref,updateobject2);
      try {
        await batch.commit();
        //console.log(q);
        console.log("gespeichert");
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      this.tools.presentAlert("GENERAL.ERROR","You can only submit questions in state SAVED");
      return false;
    }
  }

  //done
  public async reSubmitQuestion(q: Question): Promise<boolean> {
    if (q.state == QuestionState.Submitted) {   
      if (q.version>1) {
        this.tools.presentAlert("GENERAL.ERROR","Questions can only be resubmitted once");
        return false;
      } else {
        q.version++;
        let updateObject = QuestionManager.createUpdateObjectForResubmit(q);
        //await this.afs.doc("Questions/"+q.qid).update(updateObject);
        await updateDoc(doc(this.firestore, "Questions", q.qid), updateObject);
        console.log("gespeichert");
        return true;
      }
    } else {
      this.tools.presentAlert("GENERAL.ERROR","Only submitted questions can be resubmitted.");
      return false;
    }
  }

  //done
  //speichert eine Message zu einer Frage
  public async SubmitFeedback(qid: string, message: string): Promise<Message> {
    let msg: any = {
      date: this.tools.now(),
      user: {
        uid: this.user.currentAuthorizedUser.uid,
        nickname: this.user.currentAuthorizedUser.nickname
      },
      text: message,
      type: MessageType.Normal,
    };
    //let messageRef = this.afs.firestore.collection('Messages').doc(qid);
    const messageRef = doc(this.firestore, "Messages", qid);
    try {
      //let result = await this.afs.firestore.runTransaction(transaction => {
      let result = await runTransaction(this.firestore, transaction => {
        return transaction.get(messageRef).then(doc => {
          
          if (doc.exists()) {
            let messagebox = doc.data();
            let m = <Message[]> messagebox.messages; 
            m.push(msg);
            transaction.update(messageRef, { 
              lastMsgBy: this.user.currentAuthorizedUser.uid, 
              messages: m
            });
          } else {
            console.log("Document did not exist");
            let m: Message[] = [];
            m.push(msg);
            transaction.set(messageRef, { 
              qid: qid,
              lastMsgBy: this.user.currentAuthorizedUser.uid,
              messages: m
            });
          }
          

        });
      });
      return msg;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  //done
  //ladtet die Messages zu einer Frage
  public async getFeedback(qid: string): Promise<Message[] | null> {
    //let doc = await this.afs.collection("Messages").doc(qid).get().toPromise();
    let docu = await getDoc(doc(this.firestore, "Messages", qid));
    if (!docu.exists())
      return null;
    else {
      let msg = <Messages> docu.data();
      if (msg.messages)
        return <Message[]> msg.messages;
      else
        return null;
    }
  }

  //done
  public loadMyQuestions() {
    if (this.questions) return;
    //console.log(this.afAuth.currentUser);
    console.log(this.auth.currentUser);
    //console.log(this.currentCourse);
    if (this.auth.currentUser && this.currentCourse) {
      let uid = this.user.afUser.uid;
      console.log("Loading all Questions for user", uid);
      //this.itemsCollection = this.afs.collection('Questions', ref => ref
      //  .where("creator.uid","==", uid)
      //  .where("cid","==",this.currentCourse.cid)
      //);
      const queryResult = query(collection(this.firestore, 'Questions'), where("creator.uid","==", uid), where("cid","==",this.currentCourse.cid));
      //this.questionObservable = this.itemsCollection.valueChanges();
      //this.questionSubsription = this.questionObservable.subscribe((data: Question[]) => {
      this.unsubscribeQuestions = onSnapshot(queryResult, (snapshot) => {
        let data = <Question[]> snapshot.docs.map(doc => doc.data());
        console.log("Observable liefert Questions");
        this.questions = data;
        //console.log(this.questions);
      },(error)=>{
        console.log("loadQuestions Error in subscribe: ",error);
      });
    } else {
      this.tools.presentAlert("GENERAL.ERROR", "not logged in or not in course.");
    }
  }

  //done
  //Idee für später: theDoc für eine Zeitlang speichern und später wieder damit beginnen
  //um nicht jedesmal sinnlos viele Dokumente zu finden.
  public async FindQuestionToReview(mid: String): Promise<Question> {
    let searchDepth = this.currentCourse.searchDepthForQuestions || 10;
    console.log("Search Depth: ", searchDepth);
    if (this.user.afUser && this.currentCourse) {
      let found = false;
      console.log("Searching for questions in Modul !"+mid);
      console.log("searchin 1st. record");
      //let coll: AngularFirestoreCollection = this.afs.collection('Questions', ref => ref
      //  .where("mid","==",mid) 
      //  .where("cid","==",this.currentCourse.cid)
      //  .where("state","==",2) // only submitted questions
      //  .orderBy("countReviewsLatestVersion")
      //  .limit(1));
      const coll = collection(this.firestore, 'Questions');
      const queryResult = query(coll, 
          where("mid","==",mid), 
          where("cid","==",this.currentCourse.cid), 
          where("state","==",2), 
          orderBy("countReviewsLatestVersion"), 
          limit(1));
      //let snapshot = await coll.get().toPromise();
      let querySnapshot = await getDocs(queryResult);
      //let theDoc = snapshot.docs[0];
      let theDoc = querySnapshot.docs[0];
      if (!theDoc) {
        console.log("not a single question found...")
        return null;
      }
      let q:Question = <Question>theDoc.data();
      if(q.creator.uid!=this.user.currentAuthorizedUser.uid && 
        !(q.reviews.find(r=>r.user.uid==this.user.currentAuthorizedUser.uid))) {
        found = true;
        //console.log("first found question not yet reviewed",q);
      }
      let retry = 0;
      while (!found && retry<searchDepth) { //10 Versche maximal
        retry++;
        console.log("found unusable question!");
        console.log("searching "+retry+". record");
        //coll = this.afs.collection('Questions', ref => ref
        //  .where("mid","==",mid)
        //  .where("cid","==",this.currentCourse.cid)
        //  .where("state","==",2) // only submitted questions
        //  .orderBy("countReviewsLatestVersion")
        //  .startAfter(theDoc)
        //  .limit(1));
        const queryResult = query(coll, 
          where("mid","==",mid), 
          where("cid","==",this.currentCourse.cid), 
          where("state","==",2), 
          orderBy("countReviewsLatestVersion"), 
          startAfter(theDoc), 
          limit(1));
        //snapshot = await coll.get().toPromise();
        querySnapshot = await getDocs(queryResult);  
        //theDoc = snapshot.docs[0];
        theDoc = querySnapshot.docs[0];
        if (!theDoc) {
          console.log("not more questions found")
          return null;
        }
        q = <Question>theDoc.data();
        if(q.creator.uid!=this.user.currentAuthorizedUser.uid && 
          !(q.reviews.find(r=>r.user.uid==this.user.currentAuthorizedUser.uid))) {
          found = true;
          console.log("found question not yet reviewed");
        }
      }
      if (found)
        return q;
      else
        return null;
    } else {
      this.tools.presentAlert("GENERAL.ERROR", "not logged in or not in course");
    }
  }

  //done
  public async sendReview(qid: string, r: Review): Promise<ReviewStatistic> {
    //changed to Firebase function:
    //const functions = getFunctions(this.functions,'europe-west1');
    try {
      //const SR = this.fns.httpsCallable('sendReview');
      const SR = httpsCallable(this.functions, 'sendReview_v2');
      const result = await SR({
        cid: this.currentCourse.cid,
        qid: qid,
        r: r});
        console.log("sendReview");
        console.log(result.data);
        return <ReviewStatistic> result.data;
    } catch (e) {
      console.log(e);
    }

    /*let questionRef = this.afs.firestore.collection('Questions').doc(qid);
    console.log("sendReview called for qid: ", qid);
    try {
      let newStats = await this.afs.firestore.runTransaction(transaction => {
        return transaction.get(questionRef).then(question => {
          if (question.exists) {
            let q = <Question> question.data();
            //console.log("sendReview - question.data: ",question);
            let rev = q.reviews;
            r.forVersion = q.version;
            rev.push(r);
            let stats: ReviewStatistic = q.reviewStatistic;
            stats.countReviews+=1;
            stats.sumWording+=r.wording;
            stats.sumUnderstandability+=r.understandability;
            stats.avgUnderstandability = stats.sumUnderstandability / stats.countReviews;
            stats.avgWording = stats.sumWording / stats.countReviews;
            if (r.complexity==1) stats.countComplexity1++;
            if (r.complexity==2) stats.countComplexity2++;
            if (r.complexity==3) stats.countComplexity3++;
            transaction.update(questionRef, { reviews: rev,
                                              reviewStatistic: stats, 
                                              countReviewsLatestVersion: firebase.firestore.FieldValue.increment(1),
                                              lastReview: firebase.firestore.FieldValue.serverTimestamp()
                                            });
            let uref = this.afs.collection("UserCourses").doc(this.user.afUser.uid+"-"+this.currentCourse.cid).ref;
            transaction.update(uref,
              {
                points: firebase.firestore.FieldValue.increment(this.currentCourse.points.PointsPerReview),
                countReviews: firebase.firestore.FieldValue.increment(1),
                lastDay: firebase.firestore.FieldValue.serverTimestamp()
              });
            let lref = this.afs.collection("Log").doc(this.afs.createId()).ref;
            transaction.set(lref,
              {
                uid: this.user.afUser.uid, //mandatory
                cid: this.currentCourse.cid, //mandatory
                mid: q.mid, //bei Bedarf
                qid: q.qid, //bei Bedarf
                tid: "", //Trainigs-ID
                type: 2,
                logdate: firebase.firestore.FieldValue.serverTimestamp()
              });
            return stats;            
          } else {
            console.log("sendReview: Frage nicht gefunden.");
            return null;
          }
        });
      });
      return newStats;
    } catch (error) {
      console.log("sendReview:", error);
      return null;
    }   
    */ 
  }

  //done
  public unLoadMyQuestions() {
    if (this.unsubscribeQuestions) {
      this.unsubscribeQuestions();
      //this.questionObservable = null;
      //this.itemsCollection = null;
      this.questions = null;
      console.log("questionObservable released");
    }
  }

  //done
  public async getTestforModul(mid: string, countQuestions: number = 10): Promise<TestQuestion[]> {
    //Todo: Kurse cachen
    console.log("loading tests");
    let cid = this.currentCourse.cid;
    //let doc = await this.afs.collection('Tests').doc(cid+"-"+mid).get().toPromise();
    let docu = await getDoc(doc(this.firestore, "Tests", cid+"-"+mid));
    if (docu.exists()) {
      let myTests = <Test>docu.data();
      if (myTests === undefined) return null;
      let copyOfQuestions = [...myTests.questions];
      let resultset: TestQuestion[] = [];
      for (let i=1;i<=countQuestions;i++) {
        let rand: number;
        if (DEBUG_DONT_MIX_TESTS) //don't mix the questions
          rand=0;
        else
          rand = Math.floor(Math.random()*copyOfQuestions.length);
        let oneQuestion = copyOfQuestions[rand];
        copyOfQuestions.splice(rand,1);
        resultset.push(oneQuestion);
      }
      return resultset;
    } else {
      return null;
    }
  }

  //done
  public async submitTestCompletion(mid:string, countQuestions: number, type:string, testQuestions: TestQuestion[], trialLog: string): Promise<boolean> {
    //let batch = this.afs.firestore.batch();
    let batch = writeBatch(this.firestore);
    let updateobject = null;
    //build plausible question-check
    let questionCheck = [];
    if (testQuestions) {
      let pp = 0;
      testQuestions.forEach(tq=>{
        let p = 0;
        let c = 0;
        tq.answers.forEach(a=>{
          c++;
          if (a.correct) p+=c;
        });
        pp+=p;
        questionCheck.push(tq.qid);
      });
      questionCheck.push(pp);   
    }
    //UserCourse - Punkte
    //let uref = this.afs.collection("UserCourses").doc(this.user.afUser.uid+"-"+this.currentCourse.cid).ref;
    let uref = doc(this.firestore, "UserCourses", this.user.afUser.uid+"-"+this.currentCourse.cid);
    let points = 0;
    if (type=="standard") {
      points = countQuestions*this.currentCourse.points.PointsPerStandardTrainingQuestion;
      updateobject = {
        points: increment(points),
        countStandardTrainings: increment(1),
        lastDay: serverTimestamp()
      };
      //console.log(JSON.stringify(updateobject));
      batch.update(uref,updateobject);
    }
    
    if (type=="advanced") {
      points = countQuestions*this.currentCourse.points.PointsPerAdvancedTrainingQuestion;
      updateobject = {
        points: increment(points),
        countAdvancedTrainings: increment(1),
        lastDay: serverTimestamp()
      };
      //console.log(JSON.stringify(updateobject));
      batch.update(uref,updateobject);                    
    }
    
    //let lref = this.afs.collection("Log").doc(this.afs.createId()).ref;
    let lref = doc(this.firestore, "Log", doc(collection(this.firestore, "Log")).id);
    let updateobject2 = {
      uid: this.user.afUser.uid, //mandatory
      cid: this.currentCourse.cid, //mandatory
      mid: mid, //bei Bedarf
      qid: "", //bei Bedarf
      tid: this.currentCourse.cid+"-"+mid, //Trainigs-ID
      type: 5, //5=Standard-Training
      logdate: serverTimestamp(),
      info: {points: points, check: questionCheck, l: trialLog}
    }
    //console.log(JSON.stringify(updateobject2));
    batch.set(lref,updateobject2);
    try {
      await batch.commit();
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  //done
  public monitorHighScore() {
    this.HighScoreLoadingInitiated = true;
    //if (!this.highScoreSubscription && this.currentCourse) {
    //  this.highScoreSubscription = this.afs.collection("HighScore", ref => ref  
    //  .where("cid","==",this.currentCourse.cid)
    //  .orderBy("creationDate","desc")
    //  .limit(1)).valueChanges().subscribe((docs: HighScore[]) =>{
    const queryResult = query(collection(this.firestore, 'HighScore'),
      where("cid","==",this.currentCourse.cid),
      orderBy("creationDate","desc"),
      limit(1));
    this.UnsubscribeFromHighScore = onSnapshot(queryResult, (snapshot) => {
      let docs = <HighScore[]> snapshot.docs.map(doc => doc.data());
      if (docs.length>0) {
        this.highScore = <HighScore> docs[0];
        //this.highScore.items = this.highScore.items.slice(0,25); // Menge einschränken
        console.log("monitorHighScore: ",this.highScore);
        this.highScoreDateTime = this.tools.printTimestamp(this.highScore.creationDate);
        if (this.highScore.items.find(oneItem=>oneItem.uid===this.user.currentAuthorizedUser.uid)) 
          this.userIsInHighScore = true;
        else
          this.userIsInHighScore = false;
      }
    });
  }

  //done
  public stopMonitoringHighScore() {
    if (this.UnsubscribeFromHighScore) {
      this.UnsubscribeFromHighScore();
      this.UnsubscribeFromHighScore = null;
      this.highScore = null;
    }
  }

  //done
  public async loadInfoContent() {
    if (!this.infoContent) {
      let docu;
      if (this.translate.currentLang=='en')
        //doc = await this.afs.doc("Content/INFO-EN").get().toPromise();
        docu = await getDoc(doc(this.firestore, "Content", "INFO-EN"));
      else
        //doc = await this.afs.doc("Content/INFO-DE").get().toPromise();
        docu = await getDoc(doc(this.firestore, "Content", "INFO-DE"));
      if (docu.exists()) {
        this.infoContent = <Content>docu.data();
        this.infoContent
      }
    }
  }

  // Add or remove the "dark" class based on if the media query matches
  public toggleDarkTheme(shouldAdd: boolean) {
    document.body.classList.toggle('dark', shouldAdd);
  }

  public getColorForPoints(points: number): string {
    if (this.currentCourse) {
      if (points < this.currentCourse.colorYellowFromPoints)
      return "danger";
    else if (points >= this.currentCourse.colorYellowFromPoints && points<this.currentCourse.colorGreenFromPoints)
      return "warning";
    else
      return "success";
    } else
      return "danger";
    
  }
  

}
